import { render } from "./S213809.vue?vue&type=template&id=147a5086"
const script = {}
script.render = render

export default script